import Swiper from "swiper";

export default {
  init() {

    // console.log('DIETA INIT');
    const dietaId = $('#content').attr('data-page-id');
    let initialSlideDieta;

    $('.single-diet-menu-item').each(function() {
      const dietaListIdDesktop = $(this).attr('data-page-id');
      if (dietaId == dietaListIdDesktop) {
        $(this).addClass('active');
      }
    });
    $('.slide-dieta').each(function( index ) {
      const dietaListIdMobile = $(this).attr('data-page-id');
      if (dietaId == dietaListIdMobile) {
        $(this).addClass('active');
        initialSlideDieta = index;
      }
    });

    // MOBILE DIETS SLIDER
    // eslint-disable-next-line no-unused-vars
    const dietsMobile = new Swiper("#dieta-menu-mobile", {
      slidesPerView: 3,
      loop: true,
      speed: 200,
      centeredSlides: true,
      initialSlide: initialSlideDieta,
      // autoplay: {
      //   delay: 3000,
      // },
      // navigation: {
      //   nextEl: '#button-next',
      //   prevEl: '#button-prev',
      // },
    });

    // NEXT & PREV BTNS
    function getPrevNextDiet() {
      const prevDietBtn = $('#prev-diet-link');
      const nextDietBtn = $('#next-diet-link');
      const prevDietBtnMobile = $('#button-prev');
      const nextDietBtnMobile = $('#button-next');
      const firstId = $('#diets-dropdown a.single-diet-menu-item:first-child').attr('data-page-id');
      const lastId = $('#diets-dropdown a.single-diet-menu-item:last-child').attr('data-page-id');
      const firstLink = $('#diets-dropdown a.single-diet-menu-item:first-child').attr('href');
      const lastLink = $('#diets-dropdown a.single-diet-menu-item:last-child').attr('href');
      const currentPosition = $('#diets-dropdown a.active').attr('data-diet-position');
      const isFirst = (dietaId === firstId);
      const isLast = (dietaId === lastId);
      let prevLink;
      let nextLink;

      if (isFirst) {
        prevLink = lastLink;
        nextLink = $('#diets-dropdown a.single-diet-menu-item[data-diet-position=2]').attr('href');
      } else if (isLast) {
        let prevPosition = currentPosition - 1;
        prevLink = $('#diets-dropdown a.single-diet-menu-item[data-diet-position=' + prevPosition + ']').attr('href');
        nextLink = firstLink;
      } else {
        let prevPosition = parseInt(currentPosition) - 1;
        let nextPosition = parseInt(currentPosition) + 1;
        prevLink = $('#diets-dropdown a.single-diet-menu-item[data-diet-position=' + prevPosition + ']').attr('href');
        nextLink = $('#diets-dropdown a.single-diet-menu-item[data-diet-position=' + nextPosition + ']').attr('href');
      }

      prevDietBtn.attr('href', prevLink);
      nextDietBtn.attr('href', nextLink);
      prevDietBtnMobile.attr('href', prevLink);
      nextDietBtnMobile.attr('href', nextLink);

      // console.log(firstId);
      // console.log(lastId);
      // console.log(firstLink);
      // console.log(lastLink);
      // console.log(currentPosition);
      // console.log(dietaId);
      // console.log(isFirst);
      // console.log(isLast);
      // console.log(prevLink);
      // console.log(nextLink);
    }
    getPrevNextDiet();

    // TYGODNIE BUTTONS
    $('.przedzial-dat.current-week').click(function() {
      $('.przedzial-dat').removeClass('active');
      $(this).addClass('active');
      $('.day-btn').removeClass('active');
      $('.menu-content').removeClass('active');
      $('.today').addClass('active');
      $('#nasze-menu').removeClass('next');
      $('#nasze-menu').addClass('current');
    });
    $('.przedzial-dat.next-week').click(function() {
      $('.przedzial-dat').removeClass('active');
      $(this).addClass('active');
      $('.day-btn').removeClass('active');
      $('.menu-content').removeClass('active');
      $('#next-poniedzialek-menu').addClass('active');
      $('#poniedzialek-btn').addClass('active');
      $('#nasze-menu').removeClass('current');
      $('#nasze-menu').addClass('next');
    });

    // DNI TYGODNIA MENU
    $('#poniedzialek-btn').click(function() {
      $('.day-btn').removeClass('active');
      $(this).addClass('active');
      if ($('#nasze-menu').hasClass('current')) {
        $('.menu-content').removeClass('active');
        $('#current-poniedzialek-menu').addClass('active');
      } else if($('#nasze-menu').hasClass('next')) {
        $('.menu-content').removeClass('active');
        $('#next-poniedzialek-menu').addClass('active');
      }      
    });
    $('#wtorek-btn').click(function() {
      $('.day-btn').removeClass('active');
      $(this).addClass('active');
      if ($('#nasze-menu').hasClass('current')) {
        $('.menu-content').removeClass('active');
        $('#current-wtorek-menu').addClass('active');
      } else if($('#nasze-menu').hasClass('next')) {
        $('.menu-content').removeClass('active');
        $('#next-wtorek-menu').addClass('active');
      }
    });
    $('#sroda-btn').click(function() {
      $('.day-btn').removeClass('active');
      $(this).addClass('active');
      if ($('#nasze-menu').hasClass('current')) {
        $('.menu-content').removeClass('active');
        $('#current-sroda-menu').addClass('active');
      } else if($('#nasze-menu').hasClass('next')) {
        $('.menu-content').removeClass('active');
        $('#next-sroda-menu').addClass('active');
      }
    });
    $('#czwartek-btn').click(function() {
      $('.day-btn').removeClass('active');
      $(this).addClass('active');
      if ($('#nasze-menu').hasClass('current')) {
        $('.menu-content').removeClass('active');
        $('#current-czwartek-menu').addClass('active');
      } else if($('#nasze-menu').hasClass('next')) {
        $('.menu-content').removeClass('active');
        $('#next-czwartek-menu').addClass('active');
      }
    });
    $('#piatek-btn').click(function() {
      $('.day-btn').removeClass('active');
      $(this).addClass('active');
      if ($('#nasze-menu').hasClass('current')) {
        $('.menu-content').removeClass('active');
        $('#current-piatek-menu').addClass('active');
      } else if($('#nasze-menu').hasClass('next')) {
        $('.menu-content').removeClass('active');
        $('#next-piatek-menu').addClass('active');
      }
    });
    $('#sobota-btn').click(function() {
      $('.day-btn').removeClass('active');
      $(this).addClass('active');
      if ($('#nasze-menu').hasClass('current')) {
        $('.menu-content').removeClass('active');
        $('#current-sobota-menu').addClass('active');
      } else if($('#nasze-menu').hasClass('next')) {
        $('.menu-content').removeClass('active');
        $('#next-sobota-menu').addClass('active');
      }
    });
    $('#niedziela-btn').click(function() {
      $('.day-btn').removeClass('active');
      $(this).addClass('active');
      if ($('#nasze-menu').hasClass('current')) {
        $('.menu-content').removeClass('active');
        $('#current-niedziela-menu').addClass('active');
      } else if($('#nasze-menu').hasClass('next')) {
        $('.menu-content').removeClass('active');
        $('#next-niedziela-menu').addClass('active');
      }
    });

    // TESTY INTEGRACJI API - MASTERLIFE
    // GET WEEK DATES AFTER FRIDAYS NOON
    // const today = new Date("January 4, 2022 23:15:00");
    const today = new Date();
    today.getDate();

    function getThisMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6:1); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }
    function getThisTuesday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -5:2); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }
    function getThisWednesday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -4:3); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }
    function getThisThursday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -3:4); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }
    function getThisFriday(d) {
      d = new Date(d);
      const day = d.getDay();
      const diff = d.getDate() - day + (day == 0 ? -2:5); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }
    function getThisSaturday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -1:6); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }
    function getThisSunday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -0:7); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }

    function getNextMonday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? 1:8); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }
    function getNextTuesday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? 2:9); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }
    function getNextWednesday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? 3:10); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }
    function getNextThursday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? 4:11); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }
    function getNextFriday(d) {
      d = new Date(d);
      const day = d.getDay();
      const diff = d.getDate() - day + (day == 0 ? 5:12); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }
    function getNextSaturday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? 6:13); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }
    function getNextSunday(d) {
      d = new Date(d);
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? 7:14); // adjust when day is sunday
      return new Date(d.setDate(diff));
    }

    function formatDate(date) {
      var d = new Date(date),
        month = '' + (d.getMonth() + 1),
        day = '' + d.getDate(),
        year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;

      return [year, month, day].join('-');
    }

    const breakingDate = getThisFriday(new Date());
    breakingDate.setHours(23);
    breakingDate.setMinutes(59);
    breakingDate.setSeconds(59);
    //console.log("breakingDate: " + breakingDate);

    let currentMonday;
    let currentTuesday;
    let currentWednesday;
    let currentThursday;
    let currentFriday;
    let currentSaturday;
    let currentSunday;
    let startDayCurrent;
    let endDayCurrent;
    let scopeDatesCurrent;

    let nextMonday;
    let nextTuesday;
    let nextWednesday;
    let nextThursday;
    let nextFriday;
    let nextSaturday;
    let nextSunday;
    let startDayNext;
    let endDayNext;
    let scopeDatesNext;

    function getDates() {
      
      currentMonday = formatDate(getThisMonday(new Date()));
      currentTuesday = formatDate(getThisTuesday(new Date()));
      currentWednesday = formatDate(getThisWednesday(new Date()));
      currentThursday = formatDate(getThisThursday(new Date()));
      currentFriday = formatDate(getThisFriday(new Date()));
      currentSaturday = formatDate(getThisSaturday(new Date()));
      currentSunday = formatDate(getThisSunday(new Date()));
      startDayCurrent = getThisMonday(new Date());
      startDayCurrent = startDayCurrent.toLocaleDateString("pl-PL", { day: 'numeric', month: 'long' });
      endDayCurrent = getThisSunday(new Date());
      endDayCurrent = endDayCurrent.toLocaleDateString("pl-PL", { day: 'numeric', month: 'long' });
      scopeDatesCurrent = startDayCurrent + ' - ' + endDayCurrent;

      nextMonday = formatDate(getNextMonday(new Date()));
      nextTuesday = formatDate(getNextTuesday(new Date()));
      nextWednesday = formatDate(getNextWednesday(new Date()));
      nextThursday = formatDate(getNextThursday(new Date()));
      nextFriday = formatDate(getNextFriday(new Date()));
      nextSaturday = formatDate(getNextSaturday(new Date()));
      nextSunday = formatDate(getNextSunday(new Date()));
      startDayNext = getNextMonday(new Date());
      startDayNext = startDayNext.toLocaleDateString("pl-PL", { day: 'numeric', month: 'long' });
      endDayNext = getNextSunday(new Date());
      endDayNext = endDayNext.toLocaleDateString("pl-PL", { day: 'numeric', month: 'long' });
      scopeDatesNext = startDayNext + ' - ' + endDayNext;

      // console.log('THIS WEEK');
      // console.log(currentMonday);
      // console.log(currentTuesday);
      // console.log(currentWednesday);
      // console.log(currentThursday);
      // console.log(currentFriday);
      // console.log(currentSaturday;
      // console.log(currentsunday);
      // console.log('NEXT WEEK');
      // console.log(nextMonday);
      // console.log(nextTuesday);
      // console.log(nextWednesday);
      // console.log(nextThursday);
      // console.log(nextFriday);
      // console.log(nextSaturday);
      // console.log(nextSunday);

      // console.log(scopeDatesCurrent);
      // console.log(scopeDatesNext);

      // if (today < breakingDate) {

      // } else {

      // }
    }

    getDates();

    function setToday() {
      // console.log("SETTING TODAY ACTIVE IN CURRENT WEEK");
      // console.log(formatDate(today));
      // console.log(currentMonday);
      if (formatDate(today) === currentMonday) {
        // console.log("TODAY IS MONDAY");
        $('#poniedzialek-btn').addClass('today active');
        $('#current-poniedzialek-menu').addClass('today active');
      } else if (formatDate(today) === currentTuesday) {
        // console.log("TODAY IS TUESDAY");
        $('#wtorek-btn').addClass('today active');
        $('#current-wtorek-menu').addClass('today active');
      } else if (formatDate(today) === currentWednesday) {
        // console.log("TODAY IS WEDNESDAY");
        $('#sroda-btn').addClass('today active');
        $('#current-sroda-menu').addClass('today active');
      } else if (formatDate(today) === currentThursday) {
        // console.log("TODAY IS THURSDAY");
        $('#czwartek-btn').addClass('today active');
        $('#current-czwartek-menu').addClass('today active');
      } else if (formatDate(today) === currentFriday) {
        // console.log("TODAY IS FRIDAY");
        $('#piatek-btn').addClass('today active');
        $('#current-piatek-menu').addClass('today active');
      } else if (formatDate(today) === currentSaturday) {
        // console.log("TODAY IS SATURDAY");
        $('#sobota-btn').addClass('today active');
        $('#current-sobota-menu').addClass('today active');
      } else if (formatDate(today) === currentSunday) {
        // console.log("TODAY IS SUNDAY");
        $('#niedziela-btn').addClass('today active');
        $('#current-niedziela-menu').addClass('today active');
      }
    }

    setToday();

    // KONTENERY MENU DNIOWE - CURRENT WEEK
    const currentMondayMenuContainer = $('#current-poniedzialek-menu');
    const currentTuesdayMenuContainer = $('#current-wtorek-menu');
    const currentWednesdayMenuContainer = $('#current-sroda-menu');
    const currentThursdayMenuContainer = $('#current-czwartek-menu');
    const currentFridayMenuContainer = $('#current-piatek-menu');
    const currentSaturdayMenuContainer = $('#current-sobota-menu');
    const currentSundayMenuContainer = $('#current-niedziela-menu');

    // KONTENERY MENU DNIOWE - NEXT WEEK
    const nextMondayMenuContainer = $('#next-poniedzialek-menu');
    const nextTuesdayMenuContainer = $('#next-wtorek-menu');
    const nextWednesdayMenuContainer = $('#next-sroda-menu');
    const nextThursdayMenuContainer = $('#next-czwartek-menu');
    const nextFridayMenuContainer = $('#next-piatek-menu');
    const nextSaturdayMenuContainer = $('#next-sobota-menu');
    const nextSundayMenuContainer = $('#next-niedziela-menu');

    // CURRENT DIET - MASTERLIFE ID
    const crmDietId = $('#single-dieta').attr('data-crm-id');
    // console.log("crmDietId: " + crmDietId);

    // FUNKCJA WSTAWIANIA POSIŁKÓW
    function insertMenuData(data) {
      // console.log('WSTAWIAM MENU:')
      // console.log('Success:', data);

      // CURRENT WEEK
      if (!(data[currentMonday] === undefined)) {
        const currentMondayMenu = sortByKey(data[currentMonday], 'priority');
        currentMondayMenu.forEach(printCurrentMondayMenu);
      } else {
        currentMondayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }

      if (!(data[currentTuesday] === undefined)) {
        const currentTuesdayMenu = sortByKey(data[currentTuesday], 'priority');
        currentTuesdayMenu.forEach(printCurrentTuesdayMenu);
      } else {
        currentTuesdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }

      if (!(data[currentWednesday] === undefined)) {
        const currentWednesdayMenu = sortByKey(data[currentWednesday], 'priority');
        currentWednesdayMenu.forEach(printCurrentWednesdayMenu);
      } else {
        currentWednesdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }

      if (!(data[currentThursday] === undefined)) {
        const currentThursdayMenu = sortByKey(data[currentThursday], 'priority');
        currentThursdayMenu.forEach(printCurrentThursdayMenu);
      } else {
        currentThursdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }

      if (!(data[currentFriday] === undefined)) {
        const currentFridayMenu = sortByKey(data[currentFriday], 'priority');
        currentFridayMenu.forEach(printCurrentFridayMenu);
      } else {
        currentFridayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }

      if (!(data[currentSaturday] === undefined)) {
        const currentSaturdayMenu = sortByKey(data[currentSaturday], 'priority');
        currentSaturdayMenu.forEach(printCurrentSaturdayMenu);
      } else {
        currentSaturdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }

      if (!(data[currentSunday] === undefined)) {
        const currentSundayMenu = sortByKey(data[currentSunday], 'priority');
        currentSundayMenu.forEach(printCurrentSundayMenu);
      } else {
        currentSundayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }

      // NEXT WEEK
      if (!(data[nextMonday] === undefined)) {
        const nextMondayMenu = sortByKey(data[nextMonday], 'priority');
        nextMondayMenu.forEach(printNextMondayMenu);
      } else {
        nextMondayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }

      if (!(data[nextTuesday] === undefined)) {
        const nextTuesdayMenu = sortByKey(data[nextTuesday], 'priority');
        nextTuesdayMenu.forEach(printNextTuesdayMenu);
      } else {
        nextTuesdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }

      if (!(data[nextWednesday] === undefined)) {
        const nextWednesdayMenu = sortByKey(data[nextWednesday], 'priority');
        nextWednesdayMenu.forEach(printNextWednesdayMenu);
      } else {
        nextWednesdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }

      if (!(data[nextThursday] === undefined)) {
        const nextThursdayMenu = sortByKey(data[nextThursday], 'priority');
        nextThursdayMenu.forEach(printNextThursdayMenu);
      } else {
        nextThursdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }

      if (!(data[nextFriday] === undefined)) {
        const nextFridayMenu = sortByKey(data[nextFriday], 'priority');
        nextFridayMenu.forEach(printNextFridayMenu);
      } else {
        nextFridayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }

      if (!(data[nextSaturday] === undefined)) {
        const nextSaturdayMenu = sortByKey(data[nextSaturday], 'priority');
        nextSaturdayMenu.forEach(printNextSaturdayMenu);
      } else {
        nextSaturdayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }

      if (!(data[nextSunday] === undefined)) {
        const nextSundayMenu = sortByKey(data[nextSunday], 'priority');
        nextSundayMenu.forEach(printNextSundayMenu);
      } else {
        nextSundayMenuContainer.append( '<div class="dish-desc"><span class="dish-description">Menu zostanie opublikowane wkrótce!</span></div>' );
      }


      // CURRENT WEEK
      function printCurrentMondayMenu(item) {
        currentMondayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }
      function printCurrentTuesdayMenu(item) {
        currentTuesdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }
      function printCurrentWednesdayMenu(item) {
        currentWednesdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }
      function printCurrentThursdayMenu(item) {
        currentThursdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }
      function printCurrentFridayMenu(item) {
        currentFridayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }
      function printCurrentSaturdayMenu(item) {
        currentSaturdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }
      function printCurrentSundayMenu(item) {
        currentSundayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }

      // NEXT WEEK
      function printNextMondayMenu(item) {
        nextMondayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }
      function printNextTuesdayMenu(item) {
        nextTuesdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }
      function printNextWednesdayMenu(item) {
        nextWednesdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }
      function printNextThursdayMenu(item) {
        nextThursdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }
      function printNextFridayMenu(item) {
        nextFridayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }
      function printNextSaturdayMenu(item) {
        nextSaturdayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }
      function printNextSundayMenu(item) {
        nextSundayMenuContainer.append( '<div class="dish-' + item['priority'] + ' dish-desc"><span class="dish-category">' + item['mealName'] + '</span><span class="dish-description">' + item['menuMealName'] + '</span></div>' );
      }
    }

    // FUNKCJA SORTOWANIA
    function sortByKey(array, key) {
      return array.sort((a, b) => {
        let x = a[key];
        let y = b[key];

        return ((x < y) ? -1 : ((x > y) ? 1 : 0));
      });
    }

    // INSERT DATA
    // console.log($('.current-week-scope'));
    // console.log($('.next-week-scope'));

    $('.current-week-scope').html('<span class="label">aktualny tydzień</span><span>' + scopeDatesCurrent + '</span>');
    $('.next-week-scope').html('<span class="label">przyszły tydzień</span><span>' + scopeDatesNext + '</span>');

    // GET THIS DIET MENU
    const stringToDecode = '{"dietId":' + crmDietId + ',"dates":["' + currentMonday + '","' + currentTuesday + '","' + currentWednesday + '","' + currentThursday + '","' + currentFriday + '","' + currentSaturday  + '","' + currentSunday + '","' + nextMonday + '","' + nextTuesday + '","' + nextWednesday + '","' + nextThursday + '","' + nextFriday + '","' + nextSaturday  + '","' + nextSunday + '"]}';
    let criteria = encodeURIComponent(stringToDecode);

    const apiUrl = 'https://dietly.pl/api/form/open/menus?searchCriteria=' + criteria;
    let data;

    fetch(apiUrl, {
      method: 'GET',
      headers: {
        'api-key': 'masterlife',
        'company-id': 'pysznafabryka',
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    })
      .then(response => response.json())
      .then(data => {

        // console.log('Success:', data);
        // console.log(data);
        insertMenuData(data);

      })
      .catch((error) => {
        // console.error('Error:', error);
        // TODO: what to do if no menu in CRM
      });

  },
}
